import { Alert } from "@mui/material";
import { classifyMomentWhen } from "../../moment-card/components/moment-card-when";

import type { FollowUpMomentDetails } from "../server/types";
import type { FC } from "react";

export const FollowUpRecurringWarning: FC<{ details: FollowUpMomentDetails | null }> = ({
  details,
}) => {
  const classified = classifyMomentWhen(details ?? undefined);

  if (classified.type !== "triggered") return null;

  return <Alert severity="info">This Follow-Up is based on a recurring communication.</Alert>;
};
